import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import { BUMP_REDUCER_KEY, type BumpStore, type SocketState } from './bumpTypes';

type State = Pick<RootState, typeof BUMP_REDUCER_KEY>;

export const getStore = (state: State): BumpStore => state[BUMP_REDUCER_KEY];

export const getBumpSocketState = (state: State): SocketState => getStore(state).socketState;

export const doesBumpRequireOpening = createSelector(
  getBumpSocketState,
  (socketState: SocketState): boolean => socketState === 'CLOSED',
);

export const doesBumpRequireAuthentication = createSelector(
  getBumpSocketState,
  (socketState: SocketState): boolean => socketState === 'OPEN',
);

export const isBumpAuthenticed = createSelector(
  getBumpSocketState,
  (socketState: SocketState): boolean => socketState === 'AUTHENTICATED',
);
